import type { OrInputSize, OrInputTheme, OrInputVariant } from "./or-input";

export interface UseOrInputParams {
  className?: string;
  fullWidth?: boolean;
  hasError?: boolean;
  size?: OrInputSize;
  theme?: OrInputTheme;
  variant?: OrInputVariant;
}

export interface UseOrInputResult {
  inputClassName: string;
  wrapperClassName: string;
}

export function useOrInput({
  className,
  fullWidth = true,
  hasError = false,
  size = "md",
  theme = "default",
  variant = "default",
}: UseOrInputParams): UseOrInputResult {
  const wrapperClassName = [
    "or-input",
    `or-input--${variant}`,
    `or-input--${size}`,
    theme === "social" ? "or-input--social" : "",
    hasError ? "or-input--error" : "",
    fullWidth ? "or-input--full-width" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");

  return {
    wrapperClassName,
    inputClassName: "or-input__field",
  };
}
